import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  FaHome,
  FaUsers,
  FaMoneyBillWave,
  FaExchangeAlt,
  FaSignOutAlt,
  FaUniversity,
} from 'react-icons/fa';

function NavBarAdm() {
  const history = useHistory();

  const handleLogout = () => {
    localStorage.clear();
    history.push('/Login');
  };

  return (
    <nav className="admin-navbar">
      <NavLink exact to="/Dashboard" activeClassName="active">
        <FaHome />
        <span>Home</span>
      </NavLink>

      <NavLink to="/Users" activeClassName="active">
        <FaUsers />
        <span>Usuarios</span>
      </NavLink>

      <NavLink to="/CurrencyUpdate" activeClassName="active">
        <FaMoneyBillWave />
        <span>Tasa</span>
      </NavLink>

      <NavLink to="/Relation" activeClassName="active">
        <FaExchangeAlt />
        <span>Relación</span>
      </NavLink>

      <NavLink to="/Banks" activeClassName="active">
  <FaUniversity />
  <span>Bancos</span>
</NavLink>


      <button onClick={handleLogout}>
        <FaSignOutAlt />
        <span>Salir</span>
      </button>
    </nav>
  );
}

export { NavBarAdm }; 
